import {
  BrandAndMarketListItem,
  CodeAndLabel,
  DateTimeRestrictionData,
  FormDataRouteRestriction,
  GuidIdCodeAndLabel,
  ListItemValidationMessage,
  OsisRuleCreateRequest,
  OsisRuleValidationData,
  RuleFormDataAgencyOrGroup,
  SearchTravelRange,
} from '../../../integrated-client/models';

export interface IBookingCreateManagerV2EditorData extends OsisRuleCreateRequest {
  id?: string | null;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  allowEdit?: boolean;
}

export interface ICodeValidationMessage extends ListItemValidationMessage {
  code?: string;
}

export interface IOsisRuleValidationData extends OsisRuleValidationData {
  fareBasisCodes?: Array<ICodeValidationMessage> | null;
}

export interface IEditorData {
  bookingCreateManagerEditorData: IBookingCreateManagerV2EditorData;
  validation?: any;
}

export class BookingCreateManagerV2EditorData implements IBookingCreateManagerV2EditorData {
  id?: string | null;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  allowEdit?: boolean;
  osIs?: string[] | null | undefined;
  fareBasisCodes?: string[] | null | undefined;
  marketingCarriers?: GuidIdCodeAndLabel[] | null | undefined;
  accountCodes?: string[] | null | undefined;
  excludeAccountCodes?: boolean | undefined;
  bookingDateTimeRestrictionsTimeZone?: CodeAndLabel;

  constructor() {
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  bookingCreateManagerEditorData: IBookingCreateManagerV2EditorData;
  validation?: IOsisRuleValidationData;

  constructor() {
    this.bookingCreateManagerEditorData = new BookingCreateManagerV2EditorData();
  }
}
